exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".progress-bar[data-v-245c6556]{align-items:center;margin-bottom:1.25rem}.progress-bar .progress[data-v-245c6556]{position:relative;margin-bottom:0!important}.progress-bar .progress+span[data-v-245c6556]{margin-left:.625rem;min-width:2.25rem;text-align:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-245c6556","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/vue-bulma-progress-component/src/ProgressBar.vue
// module id = 2764
// module chunks = 0